export default ({ hasSubscribedSelf, subscription }) => hasSubscribedSelf || !!subscription.id
